import { CtResponse, IPagination, zget, zhttp } from "../Fetch";
import { xget, xhttp } from "../Fetchv2.js";
import { msg_massive_templates } from "../schemas/mg.schema";
import { PGSchema } from "../schemas/pg.schema.js";

interface MassiveMessages {
	from: { username: string; img: string };
	to: { uid: string; username: string; img: string };
	ttl: string;
	img: string;
	msg: string;
	tags: string[];
	via?: string;
}

export class Messenger {
	/**
	 *
	 * @param uid ID del usuario
	 * @param params Filtros de búsqueda
	 * @param token Si es una página, se debe enviar el token de la página
	 */
	getRooms(uid: string, params: { tags?: string; limit?: number; skip?: number }, token?: string) {
		return xget<{ rooms: PGSchema.rooms[]; users: PGSchema.users[] }>(`/users/${uid}/messages`, params, token ? { headers: { "app-token": token } } : {});
	}

	async createBatchMessage(uid: string, params: (Pick<PGSchema.room_msg, "u" | "m" | "v"> & { to: PGSchema.users["id"]; tags: string[] })[]) {
		const r = await zhttp<PGSchema.room_msg[]>(`/users/${uid}/messages`, "POST", params);
		return r;
	}

	async getRoom(uid: string, room: string, params: { skip?: number }) {
		const r = await xget<PGSchema.room_msg[]>(`/users/${uid}/messages/${room}`, params);
		return r;
	}

	updateRoom(uid: string, room: string, params: { tags: string[] }, token?: string) {
		return xhttp<PGSchema.room_msg>(`/users/${uid}/messages/${room}`, "PUT", params, token ? { headers: { "app-token": token } } : {});
	}

	async insertChatInRom(uid: string, rom: PGSchema.rooms["id"], params: Pick<PGSchema.room_msg, "u" | "m" | "v">) {
		const r = await xhttp<{ room: string; msg_id: string }>(`/users/${uid}/messages/${rom}`, "POST", params);
		return r;
	}

	async findRoomWithUser(pgid: string, uid: string) {
		const r = await xget<{ room: PGSchema.rooms; user: PGSchema.users }>(`/users/${pgid}/find-messages`, { uid });
		return r;
	}

	/**
	 * /users/:uid/messages/fileupload
	 *
	 */
	async fileUpload(pgid: string, form: FormData) {
		const r = await xhttp<{ url: string; delete_hash: string }>(`/users/${pgid}/messages/file`, "POST", form);
		return r;
	}
	async deleteFileUpload(pgid: string, hash: string) {
		const r = await xhttp<{ url: string; delete_hash: string }>(`/users/${pgid}/messages/file`, "DELETE", { hash });
		return r;
	}

	async chatbot(params: { body: string; from?: string; to?: string; timestamp?: number }) {
		const r = await xhttp<{ resp: string[]; answers: { text: string; state: number }[] }>(`/chatbot`, "POST", { msg: params });
		return r;
	}
}

export class Templates {
	async getTemplates(uid: string, params: IPagination): Promise<CtResponse<msg_massive_templates[]>> {
		const r = await zget(`/users/${uid}/messages/templates`, params);
		return r;
	}

	async createTemplates(uid: string, token: string, body: { m: string; title: string }): Promise<CtResponse<{ _id: string }>> {
		const r = await zhttp(`/users/${uid}/messages/templates`, "POST", { token, ...body });
		return r;
	}

	async deleteTemplates(uid: string, token: string, tid: string): Promise<CtResponse<{ ok: boolean }>> {
		const r = await zhttp(`/users/${uid}/messages/templates/${tid}`, "DELETE", { token });
		return r;
	}
}
